import { JiraProductDiscoveryLogo } from '@atlaskit/logo';

import { token } from '@atlaskit/tokens';

import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';

import { JiraYourWorkFirstPartyRecommendation } from '@post-office/components--jira-your-work-first-party-recommendation';

import { FormattedMessage, useIntl } from 'react-intl';

import { createRender } from './types';

import { type JSX } from 'react/jsx-runtime';

import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID, PRODUCT_NAME } from '../../../common/constants';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				id="growth.recommendation-jpd.jira-your-work.reasons-modal.message"
				defaultMessage="We think {jpd} will improve your team's productivity. The recommendation is based on:"
				description="Explanation of why we think the JPD recommendation will be relevant to the customer."
				values={{ jpd: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => {
		const intl = useIntl();
		const { colorMode } = useThemeObserver();

		return (
			<JiraYourWorkFirstPartyRecommendation
				data-testid="jira-your-work-message"
				onDismissed={onDismissed}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				app={{
					product: 'Jira Product Discovery',
					hamsIdentifier: HAMS_PRODUCT_ID,
					ccpProductId: CCP_PRODUCT_ID,
					logo: <JiraProductDiscoveryLogo size="small" appearance="brand" />,
					header: (
						<FormattedMessage
							id="growth.recommendation-jpd.jira-your-work.header"
							description="Header for Jira Product Discovery recommendation message in Jira Your Work"
							defaultMessage="Build right features, the right way"
						/>
					),
					description: (
						<FormattedMessage
							id="growth.recommendation-jpd.jira-your-work.description"
							description="Description for Jira Product Discovery recommendation message in Jira Your Work"
							defaultMessage="Prioritize your ideas then easily move them into delivery, without losing any details on the way."
						/>
					),
					headerImageAltText: intl.formatMessage({
						id: 'growth.recommendation-jpd.jira-your-work.header-image-alt-text',
						description:
							'Alt text for the header image in Jira Product Discovery recommendation message in Jira Your Work',
						defaultMessage:
							'An idea in Jira Product Discovery automatically turning into an Epic in Jira',
					}),
				}}
				iconColor={colorMode === 'dark' ? token('color.icon.inverse') : undefined}
			/>
		);
	});

export default render;
